import { render, staticRenderFns } from "./EmployeesSituationByEducation.vue?vue&type=template&id=1de3d2a8&scoped=true&"
import script from "./EmployeesSituationByEducation.vue?vue&type=script&lang=js&"
export * from "./EmployeesSituationByEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3d2a8",
  null
  
)

export default component.exports